module.exports = __webpack_public_path__ + "img/phone_2.1c2fde96.png";